'use client';

import { AppHeaderButton } from '@slims/ui/organisms';
import { Bell } from 'lucide-react';
import { usePathname, useRouter } from '@/lib/next/navigation';
import { useNotifications } from '@/hooks/use-notifications';
import { useAuthStore } from '@/stores/auth-store';

export function NotificationsBell() {
	const { notifications } = useNotifications();
	const role = useAuthStore((s) => s.role);
	const router = useRouter();
	const pathname = usePathname();

	const target = role === 'member' ? '/notifiche' : '/notifications';
	const inboxUnread = notifications.filter((n) => !n.letto).length;
	const isActive = pathname === target;

	function toggle() {
		if (!isActive) {
			router.push(target);
			return;
		}
		// Already on the notifications page → behave like a toggle and go back.
		// Fall back to the app home when there is no in-app history to return to
		// (e.g. the page was opened directly), so we never leave the SPA.
		const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
		if (idx > 0) {
			router.back();
		} else {
			router.push(role === 'member' ? '/dashboard' : '/members');
		}
	}

	return (
		<AppHeaderButton
			icon={<Bell />}
			title="Notifiche"
			aria-label="Notifiche"
			active={isActive}
			badge={inboxUnread}
			onClick={toggle}
		/>
	);
}
